import "./index.scss";
import classnames from "classnames";

interface iItem {
  value: string;
  pathname: string;
}
type Props = {
  menus: iItem[];
  onClick: (props: iItem) => void;
  selected: iItem;
};

const TopMenu = ({ menus, onClick, selected }: Props) => {
  return (
    <div id="top-menu-container">
      {menus.map((menu, index) => {
        return (
          <div
            onClick={() => onClick(menu)}
            key={`menu-${menu.value}-${index}`}
            className={classnames("menu", { selectedMenu: selected === menu })}
          >
            <h4>{menu.value}</h4>
          </div>
        );
      })}
    </div>
  );
};

export default TopMenu;
